<template>
<div>


<h4  class="text-center">
  
  <i class="far fa-id-card mr-2" aria-hidden="true"></i>
  <strong>{{ title }} </strong></h4>

<alert-box class="mt-2 mb-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

<form id="form_supplier" v-on:submit.prevent="submit()" autocomplete="off">
 <div class="form-group">
  
    <label for="fornitore"><strong>Fornitore   (Denominazione / Rag.sociale)</strong></label>
    <input v-focus required type="text" class="form-control bold" placeholder="" name="supplier" id = "Fornitore" v-model="supplier.supplier">
    <small>{{_supplier}}</small>

 </div> 
  
  <div class="row">
    <div class="col">
        <div class="form-group">
        <label for="PartitaIva"><strong>Partita iva</strong></label>
        <input  required type="text" class="form-control bold" placeholder="" name="vat_number" id="Partita iva" v-model="supplier.vat_number">
        </div>

    </div>
    <div class="col">
      <label for="CF"><strong>Codice fiscale</strong></label>
      <input  required type="text" class="form-control bold" placeholder="" name="fc" id="fc" v-model="supplier.fc">

    </div>
  </div>



  <div class="row">
   
   <div class="col">  
      <label for="indirizzo"><strong>Indirizzo</strong></label>
      <input required type="text" class="form-control bold" placeholder="" name="address" id = "Indirizzo" v-model="supplier.address">    
   </div>

  <div class="col">  
    <div class="form-group">
      <label for="city"><strong>Città</strong></label>
      <input  required type="text" class="form-control bold" placeholder="" name="city" id = "City" v-model="supplier.city">
    </div>
  </div>
  <div class="col">  
  
  <div class="form-group">
    <label for="city"><strong>Cap</strong></label>
    <input  required type="text" class="form-control bold" placeholder="" name="cap" id = "cap" v-model="supplier.postalCode">
  </div>
  </div>

  </div>


  <div class="form-group">
    <label for="nation"><strong>Nazione</strong></label>
    <input  required type="text" class="form-control bold" placeholder="" name="country" id = "country" v-model="supplier.country">
  </div>
  
 
  <div class="form-group">
    <label for="contact">Contatto</label>
    <input  type="text" class="form-control bold" placeholder="" name="contact" id = "" v-model="supplier.contact">
  </div>

  <div class="form-group">
    <label for="tel">Tel</label>
    <input  type="text" class="form-control bold" placeholder="" name="tel" id = "tel" v-model="supplier.tel">
  </div>
  <div class="form-group">
    <label for="email">e-Mail</label>
    <input  type="text" class="form-control bold" placeholder="" name="email" id = "email" v-model="supplier.email">
  </div>
  

    
  <button type="button" @click="$emit('close')" class="btn btn-secondary mr-2">CHIUDI</button>
  <button :disabled="bt_spinner==true" type="submit" class="btn btn-primary" >
     <i class="fas fa-save mr-2" aria-hidden="true"></i> 
    REGISTRA
     <span v-if="bt_spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>
  

  
</form>





</div>    
</template>
<script>
import { mapGetters }    from 'vuex';
import api               from '@/api';

import alertBox          from '@/components/common/AlertBox.vue'
export default {
  props: ['item'],
   components: {alertBox},  
  data () {
    return {
        bt_spinner      : false,
        supplier        : {},
        msg             : {title : '',body:'',type :0},
        title           : '',
        _supplier       : ''
        
        
    }
  },
computed: 
  {
     ...mapGetters(['company']),
  },
mounted()
    {   
          
    },
directives: {
    focus: {
      
      inserted: function(el) {
        el.focus();
      }
    }
  },
created()
  {
    this.supplier = this.item   
    this.title = Object.keys(this.item).length > 0 ? 'MODIFICA FORNITORE' : 'NUOVO FORNITORE'
    this._supplier = this.item.supplier
  }   , 
methods: 
{
   
    async submit()
    {
       
        this.bt_spinner = true            
        const sp   = {'sp'  : this.supplier.supplierId ? 'spUpdateSupplier' :  'spCreateSupplier'}        
        const data = { 'companyId' : this.company.Id}
        const json  = Object.assign(data, sp,this.supplier);
              
        await api.post(json).then(res => {
        if(res.status==200)
          {
            this.$emit('close')
          }
          else if(res.status==500)
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1
          } 
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type = 1                 
          } 
      }).catch(err => 
      {
        console.log(err.message)   
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type = 1

      }).finally(() => {
        this.bt_spinner = false
      });
     



     
       }     
    }
  
}
</script>
<style scoped>


.bold {
  font-weight: bolder;
}

.my-custom-scrollbar {
position: relative;
height: 400px;
overflow: auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}


h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

</style>